import { render, staticRenderFns } from "./ReloadCredits.vue?vue&type=template&id=116232ae"
import script from "./ReloadCredits.vue?vue&type=script&lang=js"
export * from "./ReloadCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports